// extracted by mini-css-extract-plugin
module.exports = {"installation-tips":"InstallationTips_installation-tips__Tdb_4"};